import { useRequest } from "@certn/api";
import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  showToast,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

import { Schemas } from "../../../../types";

interface HistoricalInvoicesActionsDropdownMenuProps {
  invoiceId: string;
}

export function HistoricalInvoicesActionsDropdownMenu(
  props: HistoricalInvoicesActionsDropdownMenuProps
) {
  const { t } = useTranslation();
  const { invoiceId } = props;
  const request = useRequest();

  const downloadUsageReportCSV = async (invoiceId: string) => {
    try {
      const response = await request<Schemas["LegacyUsageReportCsvResponse"]>(
        `/api/internal/client-portal/invoices/${invoiceId}/legacy-usage-report/`,
        {
          method: "GET",
        }
      );

      if (response.usage_report) {
        window.open(response.usage_report as string, "_blank");
      }
    } catch {
      showToast(t("Unable to open usage report"), { type: "error" });
    }
  };

  const openInvoiceInNewTab = async (invoiceId: string) => {
    try {
      const response = await request<Schemas["LegacyInvoicePdfResponse"]>(
        `/api/internal/client-portal/invoices/${invoiceId}/legacy-invoice/`,
        {
          method: "GET",
        }
      );
      if (response.invoice) {
        window.open(response.invoice as string, "_blank");
      }
    } catch {
      showToast(t("Unable to open invoice"), { type: "error" });
    }
  };

  return (
    <DropdownMenu
      placement="bottom end"
      triggerButton={
        <GhostIconButton
          testID="invoice-expand-menu-button"
          size="small"
          icon="more_vert"
          aria-label={t("Expand menu")}
        />
      }
      onItemAction={(key) => {
        switch (key) {
          case "view-legacy-invoice":
            openInvoiceInNewTab(invoiceId);
            break;
          case "download-legacy-usage-report":
            downloadUsageReportCSV(invoiceId);
            break;
        }
      }}
    >
      <MenuItem
        id="view-legacy-invoice"
        testID="legacy-invoice-table-expand-view-invoice-button"
      >
        <Trans>View invoice</Trans>
      </MenuItem>
      <MenuItem
        id="download-legacy-usage-report"
        testID="legacy-invoice-table-expand-download-invoice-button"
      >
        <Trans>Download usage report</Trans>
      </MenuItem>
    </DropdownMenu>
  );
}
